import React from 'react';
import './about_us.css';
import Navbar from '../home_page/navbar';
import Footer from '../home_page/footer';
import aboutUsPlaceholder from '../../Data/Assets/images/About_us_hi.png';
import LinkedIn from '../../Data/Assets/images/logos_linkedin.svg';

function AboutUs() {
  return (
    <div>
      <section>
        <Navbar></Navbar>
      </section>

      <div id="about-us-page">
        <div className="col" id="about-us-title">
          <p>
            IYNS Research
            <br />
            Foundation
          </p>
        </div>
        <div id="about-us-hero-section">
          <div id="about-us-hero-text">
            <div id="line-plus-circle">
              <div id="vertical-line"></div>
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
            <div id="hero-section-text">
              <p>
                The IYNS Research Foundation, popularly known as the IYNS Research Foundation is a
                non-profit organization established in 2014 to promote awareness and education on
                the benefits of nuclear energy and technologies. Since then, it has played a
                meaningful role in engaging youth, supporting nuclear advocacy, and fostering
                collaborations, including being a founding signatory of international nuclear
                declarations. Through initiatives ranging from educating and training students,
                promoting women in nuclear, to technology development such as designing India's
                first micro nuclear reactor, IYNS actively contributes to India's clean energy
                future, emphasizing sustainable growth and inclusive participation.
              </p>
            </div>
          </div>
          <div id="about-us-hero-image">
            <div id="about-us-image">
              <img src={aboutUsPlaceholder} alt={'about_us'} />
            </div>
          </div>
        </div>
        <div id="history">
          <p id="history-title">History</p>
          <p className="history-text">
            IYNS Research Foundation was established in 2014 by a group of young nuclear experts and
            enthusiasts with a vision towards Nuclear Independent India through awareness about
            nuclear energy as the most reliable, carbon free, clean source of energy, along with
            nuclear technologies used in non-power applications like medical, agricultural,
            etc.{' '}
          </p>
          <p className="history-text">
            One of the major challenges in the expansion of nuclear energy to its full scale is the
            lack of its awareness both in India and abroad. IYNS is committed to bridge this gap.
          </p>
          <p className="history-text">
            In 2015, nuclear professionals and scientists from over 150 societies and associations
            gathered, with the goal of opening a dialogue with policymakers and the public about the
            necessity of including nuclear energy among the carbon-free solutions to climate change.
            IYNS was one of the founding signatories of the Nuclear4Climate declaration signed in
            Paris, France for COP21.
          </p>
          <p className="history-text">
            IYNS understands the importance of educating students so that they have sound knowledge
            of advanced technologies and iSTEAM approach. IYNS started its flagship Education Boot
            Camp along with conducts various activities like campaigns seminar, workshops,
            bootcamps, etc. IYNS is also the founding entity of the ITER International Fusion
            Education initiative (InFusEd) launch in 2021.
          </p>
          <p className="history-text">
            In 2019, global nuclear societies gathered to highlight the importance of Innovation for
            the expansion of nuclear energy across the globe. Nuclear Innovation in Clean Energy
            (NICE) Declaration under Clean Energy Ministerial (CEM) was signed by the 49 nuclear
            associations in Juan-les-Pin in France. IYNS was one of its founding signatories.
          </p>
          <p className="history-text">
            2021 onwards, IYNS realized that nuclear is the only energy source which can fuel
            India's development while achieving the decarbonization goals. Hence, it started nuclear
            advocacy and contributing towards nuclear energy policy. IYNS is working towards its
            vision through its strategy of Indian Nuclear Program 2.0 Youth Led, Industry Driven.
            This time the focus is on youth and the industry as today's youth are tomorrow's
            decision makers and industry are going to drive the expansion of nuclear at a faster
            pace.
          </p>
          <p className="history-text">
            To lead by example IYNS Research Foundation established another institution, IYNS
            TechSolutions LLP In 2024. It is designing India's first micro modular nuclear reactor,
            SUK-M.
          </p>
          <p className="history-text">
            In 2025, India announced the Nuclear Energy Mission 2047 to achieve 100 GW energy goals
            through nuclear with an emphasis on Small Modular Reactors (SMRs) and Micro Modular
            Reactors (MMRs). IYNS Research Foundation supports and is fully committed to contribute
            to this milestone.
          </p>
          <p className="history-text">
            IYNS recognises the importance and equality of women in the workforce. IYNS was one of
            the founding members of Association of Women in Nuclear (Previously known as Women in
            Nuclear India or WiN-India) in 2020 and Women in Fusion in 2021.
          </p>
          <p className="history-text">IYNS believes that “Together we can, together we shall”</p>
        </div>
        <div style={{ margin: 0, padding: 0 }} id="executive-board-section">
          <div className="container-fluid" style={{ padding: 0 }}>
            <div className="col" id="executive-board">
              <p id="executive-board-title">Our Team</p>
              <p id="executive-board-text">
                The IYNS Research Foundation is a non-profit organization dedicated to spreading
                awareness about the benefits of nuclear technology and encouraging Indian youth to
                contribute.
              </p>
            </div>
          </div>
          <div className="team-info" id="team-member-1">
            <div id="team-member-1-content">
              <p className="member-designation">Founder & President</p>
              <p className="member-name">Dr. Nitendra Singh</p>
              <p className="member-description">
                Dr. Nitendra Singh is the Founder and President of IYNS Research Foundation and a
                prominent young professional in nuclear known for his leadership and advocacy in
                advancing nuclear awareness and education among youth. He is a Nuclear Engineer at
                the ITER Organization in France, specializing in nuclear safety, tritium breeding
                systems, and severe accident management of advanced reactors. Dr. Nitendra Singh
                represents a forward-thinking blend of scientific expertise and youth-led
                advocacy—working to bring nuclear technology into education, policy, and public
                discourse in India and beyond.
              </p>
              <div className="linkedIn Link">
                <a href="https://www.linkedin.com/in/singhnitendra/">
                  <img src={LinkedIn} alt="LinkedIn link"></img>
                </a>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div id="team-member-img-1"></div>
            </div>
          </div>

          <div className="team-info" id="team-member-2">
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div id="team-member-img-2"></div>
            </div>
            <div id="team-member-2-content">
              <p className="member-designation">Vice President</p>
              <p className="member-name">Dr. Samyak Munot</p>
              <p className="member-description">
                Dr. Samyak Munot is a nuclear engineer and energy policy advocate with a PhD from
                Homi Bhabha National Institute. As the Vice-President of the IYNS Research
                Foundation, he champions nuclear power's role in India's clean energy transition,
                combining technical expertise in reactor safety with global advocacy at platforms
                like COP-28, G20 and WNE.
              </p>
              <div className="linkedIn Link">
                <a href="https://www.linkedin.com/in/samyak-munot/">
                  <img src={LinkedIn} alt="LinkedIn link"></img>
                </a>
              </div>
            </div>
          </div>

          <div className="team-info" id="team-member-3">
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div id="team-member-img-3"></div>
            </div>
            <div id="team-member-3-content">
              <p className="member-designation">Co-Founder & Media Manager</p>
              <p className="member-name">Dr. Sapna Singh</p>
              <p className="member-description">
                Dr. Sapna Singh is a nuclear engineer with a PhD in nuclear reactor
                thermal-hydraulics and neutronics from Homi Bhabha National Institute. With
                experience in academia and a diverse background spanning research, academia, and
                media, she works towards changing public perception of nuclear energy—an urgent
                imperative for advancing nuclear power.
              </p>
              <div className="linkedIn Link">
                <a href="https://www.linkedin.com/in/sapna-singh-phd-736259220/">
                  <img src={LinkedIn} alt="LinkedIn link"></img>
                </a>
              </div>
            </div>
          </div>

          <div className="team-info" id="team-member-4">
            <div id="team-member-4-content">
              <p className="member-designation">Senior Policy Fellow</p>
              <p className="member-name">Mr. Gaurav U. Gullaiya</p>
              <p className="member-description">
                Mr. Gaurav U. Gullaiya specializes in nuclear energy advocacy and strategy, working
                at the crossroads of clean energy policy, technology, and international cooperation.
                His focus is on advancing India's nuclear ecosystem through youth engagement,
                strategic partnerships, and sustainable development initiatives.
              </p>
              <div className="linkedIn Link">
                <a href="https://www.linkedin.com/in/gaurav-gullaiya/">
                  <img src={LinkedIn} alt="LinkedIn link"></img>
                </a>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div id="team-member-img-4"></div>
            </div>
          </div>

          <div className="team-info" id="team-member-5">
            <div id="team-member-5-content">
              <p className="member-designation">Education Consultant</p>
              <p className="member-name">Ms. Vinita Sharat</p>
              <p className="member-description">
                With a distinguished career spanning over 25 years in education, Ms. Vinita Sharat
                offers a deep and insightful understanding of the dynamic needs of schools,
                universities, and educational organizations. She plays a pivotal role by integrating
                educational expertise with nuclear advocacy, creating a powerful synergy that
                advances both learning and awareness in the nuclear field.
              </p>
              <div className="linkedIn Link">
                <a href="https://www.linkedin.com/in/vinita-sharat-305315a0/">
                  <img src={LinkedIn} alt="LinkedIn link"></img>
                </a>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div id="team-member-img-5"></div>
            </div>
          </div>
        </div>
      </div>

      <section>
        <Footer></Footer>
      </section>
    </div>
  );
}

export default AboutUs;
